<h3>DOs in this namespace: {{ doContents.length }}</h3><pre v-for="doContent in doContents" :key="doContent.id">{{ doContent }}</pre>